module.exports = "https://r.nearpod.com/assets/media/image/user_gray_icon-779fe2c2cd8d327b13431474ceac42f2.svg";